export default {"src":"/_next/static/media/globalservices.9b723a7e.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};